import { commonViewTexts } from '../common';
import { deleteDialogCommonViewTexts } from './delete-dialog-common';

const targetName = commonViewTexts.company;

export const deleteCompanyDialogViewTexts = {
  title: targetName,
  message: deleteDialogCommonViewTexts.messageGenerator1(targetName)
} as const;
